"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _OutboundCommunication = _interopRequireDefault(require("../model/OutboundCommunication"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* OutboundCommunication service.
* @module api/OutboundCommunicationApi
* @version 3.0
*/
var OutboundCommunicationApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new OutboundCommunicationApi. 
  * @alias module:api/OutboundCommunicationApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OutboundCommunicationApi(apiClient) {
    _classCallCheck(this, OutboundCommunicationApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create an Outbound Comm for a new auth code
   * Creates an empty Outbound Communication for sending a new auth code to a Customer.<br>The target details and the 'action' of the communication need to be specified in the payload and then PUT into the SR-SSB for sending out.<br>
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutboundCommunication} and HTTP response
   */
  return _createClass(OutboundCommunicationApi, [{
    key: "createOutboundCommsAuthcodeWithHttpInfo",
    value: function createOutboundCommsAuthcodeWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OutboundCommunication["default"];
      return this.apiClient.callApi('/outboundcomms/authcode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create an Outbound Comm for a new auth code
     * Creates an empty Outbound Communication for sending a new auth code to a Customer.<br>The target details and the 'action' of the communication need to be specified in the payload and then PUT into the SR-SSB for sending out.<br>
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutboundCommunication}
     */
  }, {
    key: "createOutboundCommsAuthcode",
    value: function createOutboundCommsAuthcode() {
      return this.createOutboundCommsAuthcodeWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create an Outbound Comm for forgotten password
     * Creates an empty Outbound Communication for sending an auth code to a Customer so they can reset their password.<br>The target details and the 'action' of the Outbound Communication are specified in the payload and need to be filled out and then PUT into the SR-SSB for sending out.<br>
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutboundCommunication} and HTTP response
     */
  }, {
    key: "createOutboundCommsForgottenPasswdWithHttpInfo",
    value: function createOutboundCommsForgottenPasswdWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OutboundCommunication["default"];
      return this.apiClient.callApi('/outboundcomms/forgottenpasswd', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create an Outbound Comm for forgotten password
     * Creates an empty Outbound Communication for sending an auth code to a Customer so they can reset their password.<br>The target details and the 'action' of the Outbound Communication are specified in the payload and need to be filled out and then PUT into the SR-SSB for sending out.<br>
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutboundCommunication}
     */
  }, {
    key: "createOutboundCommsForgottenPasswd",
    value: function createOutboundCommsForgottenPasswd() {
      return this.createOutboundCommsForgottenPasswdWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify an Authcode Outbound Com.
     * Modify the Outbound Communication and send it.<br>The User and Customer ID which the Outbound Communication is to be sent to need to be set in the body of the request.<br>The template must be specified in the body, for example:<br>“messageTemplate”: “RESEND-AUTHCODE”.<br>
     * @param {Number} outboundcommsId OutboundCommsIS ID the sms message
     * @param {module:model/OutboundCommunication} outboundCommunication OutboundComms details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutboundCommunication} and HTTP response
     */
  }, {
    key: "modifyOutboundCommsAuthcodeWithHttpInfo",
    value: function modifyOutboundCommsAuthcodeWithHttpInfo(outboundcommsId, outboundCommunication) {
      var postBody = outboundCommunication;
      // verify the required parameter 'outboundcommsId' is set
      if (outboundcommsId === undefined || outboundcommsId === null) {
        throw new Error("Missing the required parameter 'outboundcommsId' when calling modifyOutboundCommsAuthcode");
      }
      // verify the required parameter 'outboundCommunication' is set
      if (outboundCommunication === undefined || outboundCommunication === null) {
        throw new Error("Missing the required parameter 'outboundCommunication' when calling modifyOutboundCommsAuthcode");
      }
      var pathParams = {
        'outboundcommsId': outboundcommsId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OutboundCommunication["default"];
      return this.apiClient.callApi('/outboundcomms/authcode/{outboundcommsId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify an Authcode Outbound Com.
     * Modify the Outbound Communication and send it.<br>The User and Customer ID which the Outbound Communication is to be sent to need to be set in the body of the request.<br>The template must be specified in the body, for example:<br>“messageTemplate”: “RESEND-AUTHCODE”.<br>
     * @param {Number} outboundcommsId OutboundCommsIS ID the sms message
     * @param {module:model/OutboundCommunication} outboundCommunication OutboundComms details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutboundCommunication}
     */
  }, {
    key: "modifyOutboundCommsAuthcode",
    value: function modifyOutboundCommsAuthcode(outboundcommsId, outboundCommunication) {
      return this.modifyOutboundCommsAuthcodeWithHttpInfo(outboundcommsId, outboundCommunication).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a forgotten password Outbound Comm
     * Modify the Forgotten Password Outbound Communication to send it.<br>The User and Customer ID which the Outbound Communication is to be sent to need to be set in the body of the request.<br>The template must be specified in the body, for example: <br>“messageTemplate”: “FORGOTTEN-PASSWORD”<br>
     * @param {Number} outboundcommsId OutboundCommsIS ID the sms message
     * @param {module:model/OutboundCommunication} outboundCommunication OutboundComms details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutboundCommunication} and HTTP response
     */
  }, {
    key: "modifyOutboundCommsForgottenPasswdWithHttpInfo",
    value: function modifyOutboundCommsForgottenPasswdWithHttpInfo(outboundcommsId, outboundCommunication) {
      var postBody = outboundCommunication;
      // verify the required parameter 'outboundcommsId' is set
      if (outboundcommsId === undefined || outboundcommsId === null) {
        throw new Error("Missing the required parameter 'outboundcommsId' when calling modifyOutboundCommsForgottenPasswd");
      }
      // verify the required parameter 'outboundCommunication' is set
      if (outboundCommunication === undefined || outboundCommunication === null) {
        throw new Error("Missing the required parameter 'outboundCommunication' when calling modifyOutboundCommsForgottenPasswd");
      }
      var pathParams = {
        'outboundcommsId': outboundcommsId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OutboundCommunication["default"];
      return this.apiClient.callApi('/outboundcomms/forgottenpasswd/{outboundcommsId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a forgotten password Outbound Comm
     * Modify the Forgotten Password Outbound Communication to send it.<br>The User and Customer ID which the Outbound Communication is to be sent to need to be set in the body of the request.<br>The template must be specified in the body, for example: <br>“messageTemplate”: “FORGOTTEN-PASSWORD”<br>
     * @param {Number} outboundcommsId OutboundCommsIS ID the sms message
     * @param {module:model/OutboundCommunication} outboundCommunication OutboundComms details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutboundCommunication}
     */
  }, {
    key: "modifyOutboundCommsForgottenPasswd",
    value: function modifyOutboundCommsForgottenPasswd(outboundcommsId, outboundCommunication) {
      return this.modifyOutboundCommsForgottenPasswdWithHttpInfo(outboundcommsId, outboundCommunication).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();